import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import isEmpty from '../../validation/is-empty';

const SelectList = ({
  name,
  value,
  label,
  error,
  onChange,
  option,
  required,
  info,
  locale,
  selected
}) => {
  return (
    <div className="form-group">
      {label && (
        <label>
          {label}
          {required && <span className="text-danger">&nbsp;*</span>}
          {!isEmpty(
            info.infos.find(
              (item) => name === item.name && locale.lang === item.lang
            )
          ) && (
              <img
                src="img/information.png"
                className="info"
                alt=""
                data-tip={
                  info.infos.find(
                    (item) => name === item.name && locale.lang === item.lang
                  ).text
                }
              />
            )}
        </label>
      )}
      <select
        className={classnames('form-control classic', {
          'is-invalid': error,
        })}
        name={name}
        value={selected === 'Accommodation' ? 'Accommodation and food service activities' : value}
        onChange={onChange}
        disabled={selected === 'Accommodation'}
      >
        <FormattedMessage id="category.SelectCategory">
          {(category) => (
            <option key={category} value="0">
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Agriculture">
          {(category) => (
            <option
              key={category}
              value="Agriculture, forestry and fishing"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Mining">
          {(category) => (
            <option
              key={category}
              value="Mining and quarrying"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Industrial">
          {(category) => (
            <option
              key={category}
              value="Industrial"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Electricity">
          {(category) => (
            <option
              key={category}
              value="Electricity, gas and heat supply, refrigeration business"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Water">
          {(category) => (
            <option
              key={category}
              value="Water supply, sewerage, waste management and remediation activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Construction">
          {(category) => (
            <option
              key={category}
              value="Construction"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Wholesale">
          {(category) => (
            <option
              key={category}
              value="Wholesale and retail trade"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Shipping">
          {(category) => (
            <option
              key={category}
              value="Shipping and storage"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Accommodation">
          {(category) => (
            <option
              key={category}
              value="Accommodation and food service activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Information">
          {(category) => (
            <option
              key={category}
              value="Information and communication"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Financial">
          {(category) => (
            <option
              key={category}
              value="Financial and insurance activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Realestate">
          {(category) => (
            <option
              key={category}
              value="Real estate activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Professional">
          {(category) => (
            <option
              key={category}
              value="Professional, scientific and technical activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Administrative">
          {(category) => (
            <option
              key={category}
              value="Administrative and support service activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Public">
          {(category) => (
            <option
              key={category}
              value="Public administration and defense; compulsory social security"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Training">
          {(category) => (
            <option
              key={category}
              value="Training"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Health">
          {(category) => (
            <option
              key={category}
              value="Health and social services"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Arts">
          {(category) => (
            <option
              key={category}
              value="Arts, entertainment and recreation"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.Other">
          {(category) => (
            <option
              key={category}
              value="Other service activities"
            >
              {category}
            </option>
          )}
        </FormattedMessage>
        <FormattedMessage id="category.unknown">
          {(category) => (
            <option
              key={category}
              value="Industry unknown"
            >
              {category}
            </option>
          )}
        </FormattedMessage>

      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

SelectList.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.array.isRequired,
};

export default SelectList;
